export default __webpack_public_path__ + "static/media/14-BB-(4-2).2002087a.jpg";